import axiosClient from 'config/axios';
import tokenConfig from 'config/auth';

import {
  GET_PRODUCT_GROUPS, ADD_CATEGORY, ADD_COMPANY, DELETE_CATEGORY, DELETE_COMPANY
} from 'redux/actionTypes';
import { category } from 'constants/expenseTypes';

export const getProductGroups = () => (dispatch, getState) => {
  axiosClient
    .get('/api/product-groups', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_PRODUCT_GROUPS,
        payload: res.data
      });
    })
    .catch(err => console.log(err))
};

export const addProductGroup = (newGroup) => (dispatch, getState) => {
  axiosClient
    .post('/api/product-groups', newGroup, tokenConfig(getState))
    .then(res => {
      if(res.data.type === category) {
        dispatch({
          type: ADD_CATEGORY,
          payload: { name: res.data.name }
        });
      }
      else {
        dispatch({
          type: ADD_COMPANY,
          payload: { name: res.data.name }
        });
      }
    })
    .catch(err => console.log(err))
};

export const deleteProductGroup = (name, isCategory) => (dispatch, getState) => {
  axiosClient
    .delete('/api/product-groups', { params: { name }, ...tokenConfig(getState) })
    .then(res => {
      if(res.status === 204) {
        if(isCategory) {
          dispatch({
            type: DELETE_CATEGORY,
            payload: { name }
          });
        }
        else {
          dispatch({
            type: DELETE_COMPANY,
            payload: { name }
          });
        }
      }
    })
    .catch(err => console.log(err))
};